import React from "react";
import { motion } from "framer-motion";

// import { AppWrap } from '../../wrapper';
import { images } from "../../constants";
import "./Header.scss";
import { NavigationDots, SocialMedia } from "../../components";

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: "easeInOut",
    },
  },
};
const Header: React.FC = () => {
  return (
    <div id="home" className="app__container ">
      <SocialMedia />
      <div className="app__wrapper app__flex">
        <div className="app__header app__flex">
          <motion.div
            whileInView={{ x: [-100, 0], opacity: [0, 1] }}
            transition={{ duration: 0.5 }}
            className="app__header-info"
          >
            <div className="app__header-badge">
              <motion.div drag className="badge-cmp app__flex">
                <span>👋</span>
                <div style={{ marginLeft: 20 }}>
                  <p className="p-text">Hello, I am</p>

                  <h1 className="head-text">Kc Pele</h1>
                </div>
              </motion.div>

              <div className="tag-cmp app__flex">
                <p className="p-text">software Developer</p>
                <p className="p-text">Freelancer</p>
              </div>
            </div>
          </motion.div>
          {/* <div className="percentage__container">
            <div className="percentage__container-content">
              <div>
                <p>HTML</p>
                <div className="container">
                  <div className="skill p-80">80%</div>
                </div>
              </div>
              <div>
                <p>CSS</p>
                <div className="container">
                  <div className="skill p-75">75%</div>
                </div>
              </div>
            </div>
            <div className="percentage__container-content">
              <div>
                <p>REACTJS</p>
                <div className="container">
                  <div className="skill p-80">80%</div>
                </div>
              </div>
              <div>
                <p>NEXTJS</p>
                <div className="container">
                  <div className="skill p-80">80%</div>
                </div>
              </div>
            </div>
            <div className="percentage__container-content">
              <div>
                <p>NODEJS</p>
                <div className="container">
                  <div className="skill p-60">60%</div>
                </div>
              </div>
              <div>
                <p>DJANGO</p>
                <div className="container">
                  <div className="skill p-55">55%</div>
                </div>
              </div>
            </div>
            <div className="percentage__container-content">
              <div>
                <p>SOLIDITY</p>
                <div className="container">
                  <div className="skill p-50">50%</div>
                </div>
              </div>
              <div>
                <p>SCAFFOLD-ETH</p>
                <div className="container">
                  <div className="skill p-78">78%</div>
                </div>
              </div>
            </div>
          </div> */}

          {/* <motion.div
            whileInView={{ opacity: [0, 1] }}
            transition={{ duration: 0.5, delayChildren: 0.5 }}
            className="app__header-img"
          ></motion.div> */}
        </div>
      </div>
      <NavigationDots active="home" />
    </div>
  );
};

export default Header;
